import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { group } from 'console';
import { takeUntil } from 'rxjs/operators';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';
import { PushToTalkService } from 'src/app/component/push-to-talk/push-to-talk-service/push-to-talk.service';
import { StaffService } from 'src/app/component/staffs/staff-service/staff.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { imageProcessing } from 'src/app/utils/image-processing-utils';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-create-group-chat-modal',
  templateUrl: './create-group-chat-modal.component.html',
  styleUrls: ['./create-group-chat-modal.component.css']
})
export class CreateGroupChatModalComponent implements OnInit, OnDestroy {

  @Input() groupData;
  preDriverList;
  preStaffList;
  @Output() onCloseModal = new EventEmitter<any>()
  @Output() onUpdate = new EventEmitter<any>()
  selectedFile
  profileImageURL
  createGroupForm: UntypedFormGroup;
  submitted = false;
  search = '';
  drivers = [];
  staffList = [];
  user;


  constructor(
    private fb: UntypedFormBuilder,
    private pushToTalk: PushToTalkService,
    private staffService: StaffService,
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
  ) { }


  ngOnInit() {

    this.createGroupForm = this.fb.group({
      profileImageURL: [''],
      name: ['', Validators.required],
      drivers: this.fb.array([], [Validators.required, this.minLengthArray(1)]),
      staffs: this.fb.array([]),
      status: ['active', Validators.required],
    })

    this.getUser();

    if (this.groupData.groupId) {
      this.getGroupById(this.groupData.groupId)
    }

  }


  getUser() {
    this.sharedDataService
      .getUser()
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.getDriverList();
        }
      });
  }

  getGroupById(id) {
    this.pushToTalk.getPushToTalkGroupById(id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.createGroupForm.patchValue({ ...data });
          this.profileImageURL = data.profileImageURL;

          for (let driverId of data.drivers) {
            this.fDrivers.push(new UntypedFormControl(driverId));
          }

          for (let staffId of data.staffs) {
            this.fStaffs.push(new UntypedFormControl(staffId));
          }

        }
      });
  }


  getDriverList() {
    this.driverService.getDrivers(this.user._id, '')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.drivers = data;
            this.preDriverList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
            this.getStaffList();
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  getStaffList() {
    //    let queryParams = {
    //   status: 'active'
    // }
    this.staffService
      .getStaffList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.drivers = [...this.drivers, ...data];
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }


  selectedUser(user) {
    if (user) {
      user.isSelected = !user.isSelected;

      if (user.isSelected) {
        if (user.roles) {
          this.fStaffs.push(new UntypedFormControl(user._id));
        } else {
          this.fDrivers.push(new UntypedFormControl(user._id));
        }
      } else {
        if (user.roles) {
          const indexToRemove = this.fStaffs.controls.findIndex(control => control.value === user._id);
          if (indexToRemove !== -1) {
            this.fStaffs.removeAt(indexToRemove);
          }
        } else {
          const indexToRemove = this.fDrivers.controls.findIndex(control => control.value === user._id);
          if (indexToRemove !== -1) {
            this.fDrivers.removeAt(indexToRemove);
          }
        }
      }
    }
  }


  checkUser(user) {
    const staff = this.fStaffs.controls.findIndex(control => control.value === user._id);
    const driver = this.fDrivers.controls.findIndex(control => control.value === user._id);

    if (staff !== -1 || driver !== -1) {
      user.isSelected = true;
    } else {
      user.isSelected = false;
    }
    return user.isSelected;
  }

  onSubmit() {
    console.log(this.createGroupForm.value, this.createGroupForm)
    this.submitted = true
    if (this.createGroupForm.invalid) {
      return;
    }

    if (this.profileImageURL) {
      this.createGroupForm.patchValue({
        profileImageURL: this.profileImageURL
      })
    }

    const payload = this.createGroupForm.value

    this.pushToTalk.createGroup(payload, this.groupData.groupId).pipe(takeUntil(componentDestroyed(this))).subscribe((data) => {
      if (data) {
        this.onUpdate.emit(data)
        this.closeModal();
      }
    })
  }

  processFile(imageInput: any) {
    imageProcessing(imageInput)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((result) => {
        this.selectedFile = result.file;
        this.profileImageURL = result.src;
      });
  }

  closeModal() {
    this.onCloseModal.emit();
  }

  get form() {
    return this.createGroupForm.controls;
  }

  get fStaffs(): UntypedFormArray {
    return this.createGroupForm.get('staffs') as UntypedFormArray;
  }

  get fDrivers(): UntypedFormArray {
    return this.createGroupForm.get('drivers') as UntypedFormArray;
  }

  minLengthArray(min: number) {
    return (formArray: UntypedFormArray) => {
      return formArray.length >= min ? null : { minLengthArray: { requiredLength: min } };
    };
  }


  onChangeStatus(event) {
    this.createGroupForm.patchValue({
      status: event.target.value
    })
  }

  isUserSelected(user) {
    return this.fStaffs.controls.some(control => control.value === user._id) ||
      this.fDrivers.controls.some(control => control.value === user._id);
  }


  ngOnDestroy(): void {
  }

}
